// Runtime polyfills applied before any app or dependency code runs. Our Vite build targets ESNext
// (modern features are NOT down-transpiled), so a bundled dependency that uses ES2022 Array/String
// `.at()` throws "at is not a function" on any JS engine that lacks it (Chrome < 92, Safari < 15.4,
// and old embedded / crawler engines). That surfaced as uncaught TypeErrors on the login page for
// such clients (observed 2026-07-09). Polyfilling `.at()` lets those paths degrade gracefully.

function at(this: { length: number;[index: number]: unknown }, index: number): unknown {
  let n = Math.trunc(index) || 0;
  if (n < 0) n += this.length;
  return n < 0 || n >= this.length ? undefined : this[n];
}

if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, 'at', { value: at, writable: true, configurable: true });
}
if (!String.prototype.at) {
  Object.defineProperty(String.prototype, 'at', { value: at, writable: true, configurable: true });
}
